export const login = 'login';
export const restore = 'restore';
export const getProfile = 'getProfile';
export const logout = 'logout';
